module.exports = __webpack_public_path__ + "static/2-673b845da8914231b8c5a7da5e2417b4.png";